module.exports = __webpack_public_path__ + "Flama-Semibold.woff?967d065fe276a319f271147810ee36e3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Semibold.woff
// module id = 936
// module chunks = 0